// @flow

import * as React from 'react'
import computeData from '../hoc/computeData'
import type { BasicProps, PropsSchema } from '../../type'
import type { Props as EasyCompProps } from '../EasyCompComponent'

type EasyCompElement = React.Element<React.ComponentType<EasyCompProps>>;

type Props = BasicProps & {
  style: { [string]: string },
  children: React.ChildrenArray<EasyCompElement>
};

@computeData()
export default class Button extends React.PureComponent<Props> {
  static schema: PropsSchema = [
    {
      type: 'select',
      key: 'openType',
      title: '按钮类型',
      options: [
        ['share', '打开分享'],
        ['getPhoneNumber', '获取手机号'],
        ['getUserInfo', '获取用户信息']
      ],
      defaultValue: 'share'
    },
    {
      type: 'event',
      title: '获取手机号成功',
      event: 'onGetPhoneNumber',
      visible: props => props.openType === 'getPhoneNumber'
    },
    {
      type: 'event',
      title: '获取用户信息成功',
      event: 'onGetUserInfo',
      visible: props => props.openType === 'getUserInfo'
    },
    'separator',
    {
      type: 'style'
    }
  ];

  actionOnGetPhoneNumber () {
    console.warn('请在小程序中调用')
  }

  actionOnGetUserInfo () {
    console.warn('请在小程序中调用')
  }

  render () {
    if (!this.props.visible) {
      return null
    }
    const { children, style } = this.props
    return <button style={style}>{children}</button>
  }
}



// WEBPACK FOOTER //
// ./src/projects/easy/public/Comps/basic/Button.js